module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card-wrapper"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix headerNav",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header-text"
  }, [_vm._v(_vm._s(_vm.gets('$商城')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "el-icon-shopping-cart-full",
    staticStyle: {
      "font-size": "33px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.showShoppingList
    }
  })])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serachKey),
      expression: "serachKey"
    }],
    staticClass: "search-value-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter keywords…"
    },
    domProps: {
      "value": (_vm.serachKey)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchProduct(_vm.serachKey)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serachKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    staticClass: "input-select",
    attrs: {
      "name": "keyword",
      "id": "keyword"
    }
  }, [_c('option', {
    attrs: {
      "value": "CnName"
    }
  }, [_vm._v(_vm._s(_vm.gets('$中文名称')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EnName"
    }
  }, [_vm._v(_vm._s(_vm.gets('$英文名称')))])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down arrow",
    staticStyle: {
      "pointer-events": "none",
      "display": "flex",
      "color": "#fff",
      "justify-content": "center",
      "align-items": "center",
      "background": "#1976d2",
      "padding-right": "10px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-group-right",
    on: {
      "click": function($event) {
        return _vm.searchProduct(_vm.serachKey, _vm.event)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "type-wrapper"
  }, [_c('div', {
    staticClass: "type-title"
  }, [_vm._v(" Home")]), _vm._v(" "), _c('div', {
    staticClass: "type-select"
  }, _vm._l((_vm.ShoppingPage.typeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "select-list"
    }, [_c('i', {
      staticClass: "el-icon-success",
      class: _vm.currentSelectType == item.ID ? 'selectTypeClass' : '',
      style: (item.colorStyle)
    }), _vm._v(" "), (_vm.language == 'CN') ? _c('div', {
      class: _vm.currentSelectType == item.ID ? 'selectTypeClass' : '',
      style: (item.colorStyle),
      on: {
        "click": function($event) {
          return _vm.selectType(index, item.ID)
        }
      }
    }, [_vm._v(_vm._s(item.CnName))]) : _c('div', {
      class: _vm.currentSelectType == item.ID ? 'selectTypeClass' : '',
      style: (item.colorStyle),
      on: {
        "click": function($event) {
          return _vm.selectType(index, item.ID)
        }
      }
    }, [_vm._v(_vm._s(item.EnName))])])
  }), 0)])]), _vm._v(" "), _c('div', {}, _vm._l((_vm.productsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mall-product",
      on: {
        "click": function($event) {
          return _vm.showProductDetail(item.ID)
        }
      }
    }, [_c('div', {
      staticClass: "recommend-box"
    }, [_c('div', {
      staticClass: "products"
    }, [_c('div', {
      staticClass: "products-mainpic"
    }, [_c('img', {
      staticStyle: {
        "visibility": "visible"
      },
      attrs: {
        "src": item.ProductUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "products-detail"
    }, [_c('div', {
      staticClass: "products-title"
    }, [_c('font', {
      staticStyle: {
        "vertical-align": "inherit"
      }
    }, [_c('font', {
      staticStyle: {
        "vertical-align": "inherit"
      }
    }, [_vm._v(_vm._s(item.EnName))])], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "el-row",
      staticStyle: {
        "margin-left": "-9px",
        "margin-right": "-9px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "el-col",
      staticStyle: {
        "padding-left": "9px",
        "padding-right": "9px",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(_vm.gets('$热度')) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "el-col",
      staticStyle: {
        "padding-left": "9px",
        "padding-right": "9px",
        "font-size": "15px",
        "color": "#f97442"
      }
    }, [_c('el-rate', {
      attrs: {
        "disabled": "",
        "show-score": "",
        "text-color": "#ff9900",
        "score-template": "{value}"
      },
      model: {
        value: (item.Evaluate),
        callback: function($$v) {
          _vm.$set(item, "Evaluate", $$v)
        },
        expression: "item.Evaluate"
      }
    })], 1)])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "el-row",
      staticStyle: {
        "margin-left": "-9px",
        "margin-right": "-9px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "el-col",
      staticStyle: {
        "padding-left": "9px",
        "padding-right": "9px",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(_vm.gets('$库存')) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "el-col",
      staticStyle: {
        "padding-left": "9px",
        "padding-right": "9px",
        "font-size": "15px",
        "color": "#f97442"
      }
    }, [_vm._v("\r\n                                \r\n                                " + _vm._s(item.Quantity) + " " + _vm._s(_vm.gets('$剩余库存')) + "\r\n                               ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "recommend-ranking",
      staticStyle: {
        "display": "flex",
        "justify-content": "flex-end"
      }
    }, [_c('div', {
      staticClass: "ranking-name",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.showProductDetail(item.ID)
        }
      }
    }, [_c('span', {
      staticClass: "ranking-name-txt"
    }, [_c('font', {
      staticStyle: {
        "vertical-align": "inherit"
      }
    }, [_c('font', {
      staticStyle: {
        "vertical-align": "inherit"
      }
    }, [_vm._v(" " + _vm._s(_vm.gets('$添加到我的产品')))])], 1)], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "recommend-ranking"
    }, [_c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.showProductDetail(item.ID)
        }
      }
    }, [_c('span', {
      staticClass: "ranking-name-txt"
    }, [_c('font', {
      staticStyle: {
        "vertical-align": "inherit"
      }
    }, [_c('font', {
      staticStyle: {
        "vertical-align": "inherit",
        "color": "#c7864d",
        "fProdnt-weight": "700"
      }
    }, [_vm._v(_vm._s(_vm.gets('$创建采购单')) + " ")])], 1)], 1)])])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "padding-top": "50px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": 1,
      "page-sizes": [20, 50, 100, 200, 500],
      "page-size": _vm.PageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.TotalCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product Description",
      "visible": _vm.dialogVisible,
      "width": "65%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "product-main-wrap"
  }, [_c('div', {
    staticClass: "img-view-wrap",
    attrs: {
      "itemprop": "image"
    }
  }, [_c('div', {
    staticClass: "aaa"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "image-viewer",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "video-wrap"
  }), _vm._v(" "), (_vm.detailPic) ? _c('img', {
    attrs: {
      "src": _vm.detailPic,
      "id": "poster",
      "alt": "产品详情图"
    }
  }) : _c('div', {
    staticStyle: {
      "width": "450px",
      "height": "450px"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "showlast arrowBtn",
    staticStyle: {
      "z-index": "2"
    },
    on: {
      "click": function($event) {
        return _vm.showLastPic()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _c('div', {
    staticClass: "small-pic"
  }, [_vm._l((_vm.smallPic), function(item, index) {
    return _c('span', {
      key: index,
      style: (_vm.currentImgID == index && _vm.hiddenBorder && 'border: 2px solid red;')
    }, [_c('img', {
      attrs: {
        "src": _vm.Urlpath + item.img,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeImg(item, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "videoWidth",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.ProductDetail.VideoUrl !== '') ? _c('video', {
    staticClass: "videoWidth",
    attrs: {
      "id": "bigVideo",
      "muted": "",
      "src": _vm.Urlpath + _vm.ProductDetail.VideoUrl,
      "controls": ""
    },
    domProps: {
      "muted": true
    }
  }, [_vm._v("\r\n                          " + _vm._s(_vm.gets('$您的浏览器不支持播放该视频！')) + " \r\n                          ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "shownext arrowBtn",
    on: {
      "click": function($event) {
        return _vm.showNextPic()
      }
    }
  }, [_vm._v(" > ")])])]), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "product-title",
    attrs: {
      "itemprop": "name"
    }
  }, [_c('h1', {
    staticClass: "product-title-text"
  }, [_c('font', {
    staticStyle: {
      "vertical-align": "inherit"
    }
  }, [_c('font', {
    staticStyle: {
      "vertical-align": "inherit",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.ProductDetail.EnName))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "split-line-thin"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-row",
    staticStyle: {
      "margin-left": "-9px",
      "margin-right": "-9px",
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "el-col",
    staticStyle: {
      "padding-left": "9px",
      "padding-right": "9px",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.gets('$热度')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "el-col",
    staticStyle: {
      "padding-left": "9px",
      "padding-right": "9px",
      "font-size": "15px",
      "color": "#f97442"
    }
  }, [_c('el-rate', {
    attrs: {
      "disabled": "",
      "show-score": "",
      "text-color": "#ff9900",
      "score-template": "{value}"
    },
    model: {
      value: (_vm.ProductDetail.Evaluate),
      callback: function($$v) {
        _vm.$set(_vm.ProductDetail, "Evaluate", $$v)
      },
      expression: "ProductDetail.Evaluate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "el-row",
    staticStyle: {
      "margin-left": "-9px",
      "margin-right": "-9px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "el-col",
    staticStyle: {
      "padding-left": "9px",
      "padding-right": "9px",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.gets('$库存')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "el-col",
    staticStyle: {
      "padding-left": "9px",
      "padding-right": "9px",
      "font-size": "15px",
      "color": "#f97442"
    }
  }, [_vm._v("\r\n                              \r\n                                " + _vm._s(_vm.ProductDetail.Quantity) + " " + _vm._s(_vm.gets('$剩余库存')) + " \r\n                               ")])]), _vm._v(" "), _c('div', {
    staticClass: "detailsWrapper"
  }, [_c('div', {
    staticClass: "detailsCont"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "detailTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.ProductDetailsArr,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.on_select,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.gets("$图片"),
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "34px",
            "height": "34px"
          },
          attrs: {
            "src": _vm.Urlpath + scope.row.ProductUrlSingle,
            "alt": ""
          },
          on: {
            "mouseover": function($event) {
              return _vm.showInPoster(scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "CnNameColumn",
      "prop": "name",
      "label": _vm.gets("$中文名称"),
      "show-overflow-tooltip": "",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.CnName))]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          staticStyle: {
            "display": "-webkit-box",
            "-webkit-line-clamp": "2",
            "-webkit-box-orient": "vertical",
            "overflow": "hidden"
          },
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("\r\n                                   " + _vm._s(scope.row.CnName) + "\r\n                                  ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": _vm.gets("$英文名称"),
      "show-overflow-tooltip": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.EnName))]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          staticStyle: {
            "display": "-webkit-box",
            "-webkit-line-clamp": "2",
            "-webkit-box-orient": "vertical",
            "overflow": "hidden"
          },
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("\r\n                                   " + _vm._s(scope.row.EnName) + "\r\n                                  ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "SKU",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.SKU))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": _vm.gets("$销售价"),
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.SalesPrice))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": _vm.gets("$库存"),
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.Quantity))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": _vm.gets("$规格"),
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.Specification))]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "flex-end",
      "margin-top": "70px"
    }
  }, [_c('div', {
    staticClass: "recommend-ranking",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_c('div', {
    staticClass: "ranking-name",
    staticStyle: {
      "width": "100%",
      "padding": "0px 30px"
    },
    on: {
      "click": function($event) {
        return _vm.AddProduct()
      }
    }
  }, [_c('span', {
    staticClass: "ranking-name-txt"
  }, [_c('font', {
    staticStyle: {
      "vertical-align": "inherit"
    }
  }, [_c('font', {
    staticStyle: {
      "vertical-align": "inherit"
    }
  }, [_vm._v(_vm._s(_vm.gets('$添加到我的产品')))])], 1)], 1), _vm._v(" "), _c('i', {
    staticClass: "ranking-arr"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "recommend-ranking"
  }, [_c('div', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.AddMallPurchase(_vm.SpecificationID)
      }
    }
  }, [_c('span', {
    staticClass: "ranking-name-txt"
  }, [_c('font', {
    staticStyle: {
      "vertical-align": "inherit"
    }
  }, [_c('font', {
    staticClass: "creatPur"
  }, [_vm._v(_vm._s(_vm.gets('$创建采购单')) + " ")])], 1)], 1)])])])])])])])]), _vm._v(" "), _c('div', [_c('h2', {
    staticStyle: {
      "margin": "50px 0px",
      "color": "#607d8b"
    }
  }, [_vm._v("Product Description")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ProductDetail.Content)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#607d8b"
    }
  }, [_vm._v(" " + _vm._s(_vm.gets("$功能")) + "：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ProductDetail.Feature))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#607d8b"
    }
  }, [_vm._v(_vm._s(_vm.gets('$描述')) + "：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ProductDetail.ProductDesc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.IsShowShoppingCar,
      "width": "70%",
      "before-close": _vm.closeDialogSKU,
      "modal-append-to-body": true,
      "append-to-body": true,
      "title": _vm.g('$我的产品')
    },
    on: {
      "update:visible": function($event) {
        _vm.IsShowShoppingCar = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('div', {
    staticClass: "app-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('page-search-table', {
    staticClass: "page_search_table",
    attrs: {
      "store": _vm.ShoppingPage,
      "fieldData": _vm.ShoppingPage.SearchEntity
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "comd",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.isSee) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.ShoppingPage.Table.OnPageChange(1, this)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$查询')))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page_content",
    staticStyle: {
      "padding": "0px 30px",
      "margin-top": "30px"
    },
    attrs: {
      "id": "page_content"
    }
  }, [_c('l-table-page-view', {
    attrs: {
      "isShowPagination": true,
      "resultData": _vm.$store.state[_vm.ShoppingPage.GN('SearchProduct')],
      "TableConfig": _vm.ShoppingPage.Table2
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogSKU()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))])], 1)], 1), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPushDialog),
      expression: "showPushDialog"
    }],
    staticClass: "pushProduct"
  }, [_c('el-card', {
    staticClass: "push-box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.gets('$上新产品')))])]), _vm._v(" "), _c('div', {
    staticClass: "push-text"
  }, _vm._l((_vm.newProductList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "push-detail"
    }, [_c('div', {
      staticClass: "num"
    }, [_c('span', {
      staticClass: "square"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', [_c('img', {
      staticStyle: {
        "width": "48px",
        "height": "48px",
        "vertical-align": "middle",
        "margin-right": "10px"
      },
      attrs: {
        "src": _vm.Urlpath + item.ProductUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "productName"
    }, [_vm._v(_vm._s(item.EnName))])])])
  }), 0)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfa0f97e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/Warehouse/MyShoppingMall.vue
// module id = 1300
// module chunks = 169